import { configureStore } from "@reduxjs/toolkit";
// import { jokesApi } from '../services/jokes_api';
import { setupListeners } from "@reduxjs/toolkit/query";
import alertReducer from "../features/alert/alert.slice";
import invoicesReducer from "../features/invoices/invoices.slice";
import loadingReducer from "../features/global_loading/global_loading.slice";
import authReducer from "../features/auth/auth.slice";
// import controlPanelReducer from "../features/control_panel/control_panel_slice";

console.log(authReducer);

export const store = configureStore({
  reducer: {
    auth: authReducer,
    alerts: alertReducer,
    loadings: loadingReducer,
    invoices: invoicesReducer,
    // controlPanel: controlPanelReducer,
  },
});
